import { useEffect, useState } from "react";

export const FEATURES = [
  {
    title: "Connect any ERP",
    body: "Files, API calls, agents and the company portal all feed one pipeline, so every company sends invoices the way that suits it.",
  },
  {
    title: "Track every invoice live",
    body: "Follow each document from received to archived, with the ASP acknowledgement and every stage in between.",
  },
  {
    title: "Compliance and audit",
    body: "Validation before submission, a sealed archive of what was sent, and an audit trail of who did what.",
  },
];

export const DWELL_MS = 5000;

/** Three feature rows; one is open at a time and the open row advances by itself.
    Hover or keyboard focus pauses it, and choosing a row restarts its timer. */
export function FeatureAccordion() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const [reduced] = useState(
    () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches,
  );

  useEffect(() => {
    if (paused || reduced) return;
    const id = window.setTimeout(() => setActive((i) => (i + 1) % FEATURES.length), DWELL_MS);
    return () => window.clearTimeout(id);
  }, [active, paused, reduced]);

  return (
    <div
      className={`feat${paused || reduced ? " is-paused" : ""}`}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      {FEATURES.map((f, i) => {
        const open = i === active;
        return (
          <div key={f.title} className={`feat-item${open ? " is-open" : ""}`}>
            <button
              type="button"
              className="feat-head"
              aria-expanded={open}
              aria-controls={`feat-panel-${i}`}
              id={`feat-head-${i}`}
              onClick={() => setActive(i)}
            >
              <span className="feat-num">{String(i + 1).padStart(2, "0")}</span>
              <span className="feat-title">{f.title}</span>
              <span className="feat-chev" aria-hidden="true" />
            </button>
            <div className="feat-panel" id={`feat-panel-${i}`} role="region" aria-labelledby={`feat-head-${i}`}>
              <p>{f.body}</p>
            </div>
            <span
              key={`${i}-${paused}`}
              className="feat-bar"
              aria-hidden="true"
              style={{ animationDuration: `${DWELL_MS}ms` }}
            />
          </div>
        );
      })}
    </div>
  );
}
